export const data =[
    {
     id:1,
     img :"https://images.pexels.com/photos/5849573/pexels-photo-5849573.jpeg",
     title : "Web Design & Development",
     body:" Lorem ipsum, dolor sit amet consectetur adipisicing elit. Cum reiciendis pariatur eum error aut commodi?"
 },
 {
     id:2,
     img :"https://images.pexels.com/photos/6289025/pexels-photo-6289025.jpeg",
     title : "Mobile App Development",
     body:" Lorem ipsum, dolor sit amet consectetur adipisicing elit. Cum reiciendis pariatur eum error aut commodi?"
 },
 {
     id:4,
     img :"https://images.pexels.com/photos/669622/pexels-photo-669622.jpeg",
     title : "E - Commerce Solutions",
     body:" Lorem ipsum, dolor sit amet consectetur adipisicing elit. Cum reiciendis pariatur eum error aut commodi?"
 },
 {
     id:3,
     img :"https://images.pexels.com/photos/38568/apple-imac-ipad-workplace-38568.jpeg",
     title : "Search Engine Optimization",
     body:" Lorem ipsum, dolor sit amet consectetur adipisicing elit. Cum reiciendis pariatur eum error aut commodi?"
 }
]